var map = {
	"./about-career-1.jpg": "5406",
	"./about-career-2.jpg": "cda8",
	"./about-career-3.jpg": "098a",
	"./about-dots-mobile.svg": "9e04",
	"./about-dots.png": "808f",
	"./about-dots.svg": "d548",
	"./adcolony.svg": "2bb2",
	"./aliexpress.svg": "1581",
	"./amediateka.svg": "a381",
	"./anti-fraud.svg": "a320",
	"./articles-img/google-arbitrage.svg": "0127",
	"./articles-img/google-traffic/img1.png": "72d7",
	"./articles-img/google-traffic/img2.png": "b068",
	"./articles-img/google-traffic/img3.png": "e157",
	"./articles-img/traffic-arbitrage.png": "56fa",
	"./articles-img/traffic-img.png": "c9d3",
	"./automation.svg": "a3bb",
	"./betsson.svg": "3acc",
	"./betway.svg": "cd8b",
	"./border-left.svg": "12ad",
	"./bottom-border.svg": "129c",
	"./burger-close.svg": "4620",
	"./burger.svg": "4a3d",
	"./casumo.svg": "eb78",
	"./chart.svg": "57a6",
	"./check-ok.svg": "01f0",
	"./close.svg": "2930",
	"./coral.svg": "85a2",
	"./creative.svg": "f7be",
	"./dots.png": "fcb2",
	"./dots.svg": "43b2",
	"./dunder.svg": "e217",
	"./envelope.svg": "5e45",
	"./expertise.svg": "1b36",
	"./facebook.svg": "44c6",
	"./finance.svg": "10bd",
	"./five-star.svg": "b038",
	"./flag-brazil.svg": "2443",
	"./four-star.svg": "f4af",
	"./foxygames.svg": "48dc",
	"./friday.svg": "50b4",
	"./gaff.svg": "345c",
	"./gdetraffic_logo.png": "eed9",
	"./gett.svg": "c5eb",
	"./ggpoker.svg": "8794",
	"./green-arrow.svg": "4ce6",
	"./header-bg.png": "206d",
	"./header-dots-mobile.svg": "a216",
	"./header-dots.png": "4904",
	"./header-dots.svg": "e3d9",
	"./header-lighting.svg": "fa33",
	"./icons.svg": "c2ce",
	"./igg.svg": "a00c",
	"./infrastructure.svg": "2a1b",
	"./inst-colored.svg": "ddef",
	"./insta.svg": "f65a",
	"./joom.svg": "cd9f",
	"./ladbrokes.svg": "333a",
	"./leovegas.svg": "a551",
	"./logo.svg": "e347",
	"./lotter.svg": "7a35",
	"./modal-background.svg": "5fb1",
	"./modal-border-bottom.svg": "7081",
	"./modal-button-1.svg": "06f5",
	"./modal-button-2.svg": "0aaa",
	"./modal-gradient-circle.svg": "b36a",
	"./mrgreen.svg": "f08f",
	"./mrq.svg": "4c05",
	"./ourvalues-chart.svg": "d627",
	"./ourvalues-people.svg": "de05",
	"./ourvalues-safety.svg": "bcec",
	"./partnerkin_logo.png": "3bc6",
	"./parymatch.svg": "b390",
	"./people.svg": "d3cb",
	"./place.svg": "2685",
	"./play.svg": "53e0",
	"./protraffic.svg": "730b",
	"./red-star.svg": "6478",
	"./resources/apple.svg": "8332",
	"./resources/facebook.svg": "045e",
	"./resources/google.svg": "5fcd",
	"./resources/snapchat.svg": "6c03",
	"./resources/tiktok.svg": "c182",
	"./resources/twitter.svg": "d99b",
	"./rizk.svg": "0635",
	"./royalpanda.svg": "5afd",
	"./safety.svg": "f00a",
	"./salut1.png": "08ae",
	"./salut1.svg": "72b5",
	"./salut2.png": "9da7",
	"./salut2.svg": "e0ef",
	"./sg.png": "021f",
	"./sphere1.svg": "41f1",
	"./sphere2.svg": "a78c",
	"./sphere3.svg": "dd0b",
	"./sphere4.svg": "06d4",
	"./sphere5.svg": "ebe8",
	"./sphere6.svg": "7b66",
	"./telegram-colored.svg": "41ff",
	"./telegram.svg": "0c86",
	"./tgicon.svg": "8ba6",
	"./tt.png": "be84",
	"./tt2.png": "cb18",
	"./twitter.svg": "1538",
	"./unity.svg": "6aa1",
	"./unlimit.svg": "0faa",
	"./williamhill.svg": "9740",
	"./winline.svg": "d951",
	"./workplay-1.jpg": "0ef3",
	"./workplay-10.jpg": "01ba",
	"./workplay-11.jpg": "344d",
	"./workplay-12.jpg": "bafa",
	"./workplay-13.jpg": "dc86",
	"./workplay-14.jpg": "a378",
	"./workplay-15.jpg": "ecf2",
	"./workplay-16.jpg": "1e73",
	"./workplay-2.jpg": "9976",
	"./workplay-3.jpg": "86bf",
	"./workplay-4.jpg": "c756",
	"./workplay-5.jpg": "e73c",
	"./workplay-6.jpg": "7aa0",
	"./workplay-7.jpg": "f629",
	"./workplay-8.jpg": "fbd8",
	"./workplay-9.jpg": "a94b",
	"./workplay-icons.svg": "74a1",
	"./workplay-video-1.jpg": "3e7f",
	"./workplay-video-2.jpg": "1659"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";